var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStereoSpeakerOutlet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.37,9.45 6.87,9.45 6.87,4.51 0.97,4.51 0.97,4.01 7.37,4.01  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "9.54,11.74 9.04,11.74 9.04,9.53 5.17,9.53 5.17,11.74 4.67,11.74 4.67,9.03 9.54,9.03  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.61,7.8V4.58h2.18v0.38H9.04v1h1.52v0.38H9.04V7.8H8.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.59,7.8V4.58h0.64L13,6.86c0.07,0.21,0.12,0.37,0.15,0.48c0.04-0.12,0.09-0.29,0.17-0.52l0.77-2.25h0.57V7.8h-0.41 V5.1l-0.94,2.7h-0.39l-0.93-2.75V7.8H11.59z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStereoSpeakerOutlet);
export default __webpack_public_path__ + "static/media/StereoSpeakerOutlet.0f9815e32569cfab9c288a2e581e019d.svg";
export { ForwardRef as ReactComponent };